// extracted by mini-css-extract-plugin
export default {"container":"RolesAndPermissions__container___KN_0h","switchContainer":"RolesAndPermissions__switchContainer___oUbFU","labelContainer":"RolesAndPermissions__labelContainer___Ei0S8"};